import * as domainConstants from "../../constants/DomainConstants";
import { uploadOneInfrastructuurFile, deleteOneInfrastrucuurFile } from "../common/DownloadUploadFilesHelper";

import mergeDeep from "../../util/mergeDeep.js";

import showToastr, { showToastrError, showToastrInfo, showToastrSuccess } from "../../util/toastr.js";
import { getStore } from "../../store/configureStore";
import { ValidationMessageTypes } from "../../constants/ComponentConstants";

export default class MinimaleEisenPerInfrastructuurPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	update(nextProps) {
		const { infrastructuurId } = nextProps;

		if (this.context.state.requestedId != infrastructuurId) {
			this.context.setState({
				requestedId: infrastructuurId,
				hasUnsavedChanges: false
			});
			this.context.props.loadMinimaleEisenPerInfrastructuur(infrastructuurId);

			if (this.context.props.dossierId) {
				this.context.props.getContent(this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen, infrastructuurId)
					.then(result => {
						if (result.success) {
							this.context.setState(
								{
									documenten: result.data
								});
						} else {
							showToastrError("Laden van het dossier is mislukt");
							throw new Error("getContent load failed"); //Stops promise
						}
					});
			}

			this.context.props.getSjablonen(domainConstants.DocumentTab.MinimaleEisen)
				.then(result => {
					if (result.success) {
						this.context.setState(
							{
								sjablonen: result.data
							});
					} else {
						showToastrError("Laden van de sjablonen is mislukt");
						throw new Error("getSjablonen load failed"); //Stops promise
					}
				});
		}

		if (this.context.props.minimaleEisenPerInfrastructuur !== nextProps.minimaleEisenPerInfrastructuur) {
			if (nextProps.minimaleEisenPerInfrastructuur.tabTitel) {
				this.context.props.loadLayout(nextProps.minimaleEisenPerInfrastructuur.naam, nextProps.minimaleEisenPerInfrastructuur.tabTitel, nextProps.dossierId, nextProps.minimaleEisenPerInfrastructuur.typeDossier, nextProps.infrastructuurId, (nextProps.minimaleEisenPerInfrastructuur.redenVanStatus != "121450000" && nextProps.minimaleEisenPerInfrastructuur.redenVanStatus !== 121450000));
			}

			let minimaleEisenPerInfrastructuur = mergeDeep({}, nextProps.minimaleEisenPerInfrastructuur);

			if (minimaleEisenPerInfrastructuur.aanvragers.length === 1) {
				if (!minimaleEisenPerInfrastructuur.titularisId || minimaleEisenPerInfrastructuur.titularisId == '')
					minimaleEisenPerInfrastructuur.titularisId = minimaleEisenPerInfrastructuur.aanvragers[0].id;
			}

			this.context.setState({
				minimaleEisenPerInfrastructuur: minimaleEisenPerInfrastructuur,
				titleSet: nextProps.minimaleEisenPerInfrastructuur.tabTitel,
				errors: nextProps.errors,
				validationMessageType: nextProps.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING
			});
		}
	}

	init() {
		const dossierId = this.context.props.dossierId;
		this.context.props.loadLayout("", "", dossierId, "", this.context.props.infrastructuurId);
		this.context.props.loadInfrastructurenByDossierId(dossierId);
	}

	onChange(event, data) {
		const field = event.target.name;
		const minimaleEisen = this.context.state.minimaleEisenPerInfrastructuur;
		minimaleEisen[field] = event.target.type === "checkbox" ? event.target.checked : event.target.value;
		if (event.target.value === "true") {
			switch (field) {
				case "bpaVanToepassing":
					minimaleEisen.rupVanToepassing = null;
					minimaleEisen.naamVanRUP = null;
					minimaleEisen.rup = null;
					break;
			}
		}
		if (event.target.value === "false") {
			switch (field) {
				case "werkvergunningPlichtigStedenbouw":
				case "werkvergunningPlichtigLeefmilieu":
					if ((minimaleEisen.werkvergunningPlichtigStedenbouw === false || minimaleEisen.werkvergunningPlichtigStedenbouw == "false") && (minimaleEisen.werkvergunningPlichtigLeefmilieu === false || minimaleEisen.werkvergunningPlichtigLeefmilieu == "false"))
						minimaleEisen.vergunninstedenbouwKundigeBestemminggsPlichtig = "";
					minimaleEisen.vergunningAlAanwezig = null;
					minimaleEisen.merVanToepassing = null;
					minimaleEisen.naamVanMER = null;
					minimaleEisen.merStandVanZaken = null;
					minimaleEisen.naamVanRUP = null;
					minimaleEisen.naamVanHetBPA = null;
					minimaleEisen.toelichtingInplanting = null;
					//delete files
					break;
				case "latenDeVoorschriftenInplantingToe":
					minimaleEisen.toelichtingInplanting = null;
					break;
				case "vergunningAlAanwezig":
					//delete files
					break;
				case "isHetProjectEnergetischDuurzaam":
					//delete files
					break;
				case "bpaVanToepassing":
					minimaleEisen.naamVanHetBPA = null;
					break;
				case "rupVanToepassing":
					minimaleEisen.naamVanRUP = null;
					break;
				case "merVanToepassing":
					minimaleEisen.merStandVanZaken = null;
					break;
				case "projectBesprokenMetGemeentedienstStedenbouw":
					minimaleEisen.standpuntVanGemeentedienstStedenbouw = null;
					break;
			}
		}

		if (event.target.value == "121450000" || event.target.value === 121450000) {
			switch (field) {
				case "merStandVanZaken":
					minimaleEisen.naamVanMER = null;
					break;
			}
		}

		return this.context.setState({
			minimaleEisenPerInfrastructuur: minimaleEisen,
			hasUnsavedChanges: true
		});
	}

	onChangeDateNVT(event, dateField) {
		const field = event.target.name;
		const minimaleEisen = this.context.state.minimaleEisenPerInfrastructuur;
		if (minimaleEisen[field] == false) {
			minimaleEisen[field] = true;
		} else {
			minimaleEisen[dateField] = "";
			minimaleEisen[field] = false;
		}

		return this.context.setState({
			minimaleEisenPerInfrastructuur: minimaleEisen,
			hasUnsavedChanges: true
		});
	}

	onCopyMijlpalen(infrastructuurIdToCopyFrom) {
		let minimaleEisen = this.context.state.minimaleEisenPerInfrastructuur;
		this.context.props.getMinimaleEisenPerInfrastructuur(infrastructuurIdToCopyFrom)
			.then(item => {
				minimaleEisen.opmerkingenAanvraagOmgevingsvergunning = item.opmerkingenAanvraagOmgevingsvergunning;
				minimaleEisen.opmerkingenDefinitieveOplevering = item.opmerkingenDefinitieveOplevering;
				minimaleEisen.opmerkingenEindeOverheidsopdracht = item.opmerkingenEindeOverheidsopdracht;
				minimaleEisen.opmerkingenInschatttingDatumRUP = item.opmerkingenInschatttingDatumRUP;
				minimaleEisen.opmerkingenOpening = item.opmerkingenOpening;
				minimaleEisen.opmerkingenOpstartOverheidsopdracht = item.opmerkingenOpstartOverheidsopdracht;
				minimaleEisen.opmerkingenStartWerken = item.opmerkingenStartWerken;
				minimaleEisen.opmerkingenVerkrijgenOmgevingsvergunning = item.opmerkingenVerkrijgenOmgevingsvergunning;
				minimaleEisen.opmerkingenVoorlopigeOplevering = item.opmerkingenVoorlopigeOplevering;

				minimaleEisen.vanToepassingAanvragOmgevingsvergunning = item.vanToepassingAanvragOmgevingsvergunning;
				minimaleEisen.vanToepassingDefinitieveOplevering = item.vanToepassingDefinitieveOplevering;
				minimaleEisen.vanToepassingEindeOverheidsopdracht = item.vanToepassingEindeOverheidsopdracht;
				minimaleEisen.vanToepassingInschattingDatumRUP = item.vanToepassingInschattingDatumRUP;
				minimaleEisen.vanToepassingOpening = item.vanToepassingOpening;
				minimaleEisen.vanToepassingOpstartOverheidsopdracht = item.vanToepassingOpstartOverheidsopdracht;
				minimaleEisen.vanToepassingStartWerken = item.vanToepassingStartWerken;
				minimaleEisen.vanToepassingVerkrijgenOmgevingsvergunning = item.vanToepassingVerkrijgenOmgevingsvergunning;
				minimaleEisen.vanToepassingVoorlopigeOplevering = item.vanToepassingVoorlopigeOplevering;

				minimaleEisen.aanvraagOmgevingsvergunning = item.aanvraagOmgevingsvergunning;
				minimaleEisen.definitieveOplevering = item.definitieveOplevering;
				minimaleEisen.eindeOverheidsopdracht = item.eindeOverheidsopdracht;
				minimaleEisen.inschattingDatumRUP = item.inschattingDatumRUP;
				minimaleEisen.opening = item.opening;
				minimaleEisen.opstartOverheidsopdracht = item.opstartOverheidsopdracht;
				minimaleEisen.startWerken = item.startWerken;
				minimaleEisen.verkrijgenOmgevingsvergunning = item.verkrijgenOmgevingsvergunning;
				minimaleEisen.voorlopigeOplevering = item.voorlopigeOplevering;

				this.context.setState({
					minimaleEisenPerInfrastructuur: minimaleEisen,
					hasUnsavedChanges: true
				});
			});
	}

	onCopyZakelijkRecht(infrastructuurIdToCopyFrom) {
		let minimaleEisen = this.context.state.minimaleEisenPerInfrastructuur;
		this.context.props.getMinimaleEisenPerInfrastructuur(infrastructuurIdToCopyFrom)
			.then(item => {
				minimaleEisen.heeftAanvragerLandurigZakelijkRecht = item.heeftAanvragerLandurigZakelijkRecht;
				minimaleEisen.welkOnroerendZakelijkRecht = item.welkOnroerendZakelijkRecht;
				minimaleEisen.zakelijkRechtId = item.zakelijkRechtId;
				minimaleEisen.titularisId = item.titularisId;
				minimaleEisen.startdatumZakelijkRecht = item.startdatumZakelijkRecht;
				minimaleEisen.einddatumZakelijkRecht = item.einddatumZakelijkRecht;
				minimaleEisen.toelichtingAnderOnroerendZakelijkRecht = item.toelichtingAnderOnroerendZakelijkRecht;
				minimaleEisen.motiveringSportVlaanderenHeeftAanvragerLangdurigZakelijkRecht = item.motiveringSportVlaanderenHeeftAanvragerLangdurigZakelijkRecht;

				this.copyDocumentsFromInfrastructuur(infrastructuurIdToCopyFrom, domainConstants.ComponentName.BewijsEigendom);
				this.copyDocumentsFromInfrastructuur(infrastructuurIdToCopyFrom, domainConstants.ComponentName.BewijsZakelijkRecht);

				this.context.setState({
					minimaleEisenPerInfrastructuur: minimaleEisen,
					hasUnsavedChanges: true
				});
			});
	}

	onCopyDuurzaamheid(infrastructuurIdToCopyFrom) {
		let minimaleEisen = this.context.state.minimaleEisenPerInfrastructuur;
		this.context.props.getMinimaleEisenPerInfrastructuur(infrastructuurIdToCopyFrom)
			.then(item => {
				minimaleEisen.isHetProjectEnergetischDuurzaam = item.isHetProjectEnergetischDuurzaam;

				this.copyDocumentsFromInfrastructuur(infrastructuurIdToCopyFrom, domainConstants.ComponentName.Engagementsverklaring);

				this.context.setState({
					minimaleEisenPerInfrastructuur: minimaleEisen,
					hasUnsavedChanges: true
				});
			});
	}

	onCopyHaalbaarheid(infrastructuurIdToCopyFrom) {
		let minimaleEisen = this.context.state.minimaleEisenPerInfrastructuur;
		this.context.props.getMinimaleEisenPerInfrastructuur(infrastructuurIdToCopyFrom)
			.then(item => {
				minimaleEisen.stedenbouwkundigeBestemming = item.stedenbouwkundigeBestemming;
				minimaleEisen.toelichtingAndereStedenbouwkundigeBestemming = item.toelichtingAndereStedenbouwkundigeBestemming;
				minimaleEisen.gewestplan = item.gewestplan;
				minimaleEisen.bpa = item.bpa;
				minimaleEisen.rup = item.rup;
				minimaleEisen.projectBesprokenMetGemeentedienstStedenbouw = item.projectBesprokenMetGemeentedienstStedenbouw;
				minimaleEisen.standpuntVanGemeentedienstStedenbouw = item.standpuntVanGemeentedienstStedenbouw;
				minimaleEisen.werkvergunningPlichtigStedenbouw = item.werkvergunningPlichtigStedenbouw;
				minimaleEisen.werkvergunningPlichtigLeefmilieu = item.werkvergunningPlichtigLeefmilieu;
				minimaleEisen.vergunningAlAanwezig = item.vergunningAlAanwezig;
				minimaleEisen.merVanToepassing = item.merVanToepassing;
				minimaleEisen.merStandVanZaken = item.merStandVanZaken;
				minimaleEisen.naamVanMER = item.naamVanMER;

				this.copyDocumentsFromInfrastructuur(infrastructuurIdToCopyFrom, domainConstants.ComponentName.Gewestplan);
				this.copyDocumentsFromInfrastructuur(infrastructuurIdToCopyFrom, domainConstants.ComponentName.BPAPlan);
				this.copyDocumentsFromInfrastructuur(infrastructuurIdToCopyFrom, domainConstants.ComponentName.BPAVoorwaarden);
				this.copyDocumentsFromInfrastructuur(infrastructuurIdToCopyFrom, domainConstants.ComponentName.RUPPlan);
				this.copyDocumentsFromInfrastructuur(infrastructuurIdToCopyFrom, domainConstants.ComponentName.RUPVoorwaarden);
				this.copyDocumentsFromInfrastructuur(infrastructuurIdToCopyFrom, domainConstants.ComponentName.Vergunning);

				this.context.setState({
					minimaleEisenPerInfrastructuur: minimaleEisen,
					hasUnsavedChanges: true
				});
			});
	}

	copyDocumentsFromInfrastructuur(fromInfrastructuurId, componentName) {
		this.context.props.getContent(this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen, fromInfrastructuurId)
			.then(result => {
				if (result.success) {
					const documenten = result.data;
					const folder = documenten.find(x => x.name === componentName);
					if (folder && folder.files && folder.files.length > 0) {
						folder.files.forEach(file => {
							this.downloadAndUploadFile(fromInfrastructuurId, componentName, file.name);
						});
					}
				}
			});
	}

	downloadAndUploadFile(fromInfrastructuurId, component, filename) {
		const downloadUrl = `/api/document/${this.context.props.dossierId}/infrastructuur/${fromInfrastructuurId}/${domainConstants.DocumentTab.MinimaleEisen}/${component}/${filename}/false`;

		fetch(downloadUrl)
			.then(response => response.blob())
			.then(blob => {
				const file = new File([blob], filename, { type: blob.type });

				if (!this.context.state.fileSessionStarted) {
					this.context.props.startFileSession(this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen, this.context.props.infrastructuurId)
						.then(result => {
							if (result.success) {
								this.context.setState({ fileSessionStarted: true });
								this.uploadFile(component, file);
							}
						});
				} else {
					this.uploadFile(component, file);
				}
			})
			.catch(error => {
				showToastrError(`Kopiëren van ${filename} is mislukt`);
			});
	}

	uploadFile(component, file) {
		let data = new FormData();
		data.append(1, file);

		this.context.props.uploadDocument(
			this.context.props.dossierId,
			domainConstants.DocumentTab.MinimaleEisen,
			component,
			this.context.props.infrastructuurId,
			data
		).then(result => {
			if (result.success) {
				let documenten = this.context.state.documenten;
				let folder = documenten.find(x => x.name === component);
				if (!folder.files)
					folder.files = [];

				const newFileObject = {
					createdOn: new Date(),
					id: null,
					name: file.name,
					path: null
				};

				folder.files = folder.files.filter(x => x.name !== newFileObject.name);
				folder.files.push(newFileObject);

				this.context.setState({
					documenten: documenten,
					hasUnsavedChanges: true
				});
			} else {
				showToastrError("De upload van " + file.name + " is mislukt");
			}
		});
	}

	handleFileRequest(component, actionParam, fileProcess) {
		if (!this.context.state.fileSessionStarted) {
			this.context.props.startFileSession(this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen, this.context.props.infrastructuurId)
				.then(result => {
					if (!result.success) {
						showToastrError("Verwerken van bestand is mislukt");
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: true });
					}
				}).then(() => fileProcess(component, actionParam));
		}
		else
			fileProcess(component, actionParam);
	}

	onDropFiles(component, files) {
		this.handleFileRequest(component, files, () => { files.forEach(file => uploadOneInfrastructuurFile(this.context, this.context.props.uploadDocument, this.context.props.dossierId, this.context.props.infrastructuurId, domainConstants.DocumentTab.MinimaleEisen, component, file)); });
	}

	onDeleteFile(component, fileName) {
		this.handleFileRequest(component, fileName, () => { deleteOneInfrastrucuurFile(this.context, this.context.props.deleteDocument, this.context.props.dossierId, this.context.props.infrastructuurId, domainConstants.DocumentTab.MinimaleEisen, component, fileName); });
	}

	clearRechtenVelden(minimaleEisen) {
		if (minimaleEisen.heeftAanvragerLandurigZakelijkRecht === "false") {
			minimaleEisen.welkOnroerendZakelijkRecht = null;
			minimaleEisen.zakelijkRechtId = null;
			minimaleEisen.motiveringSportVlaanderenHeeftAanvragerLangdurigZakelijkRecht = "";
			minimaleEisen.titularisId = null;
			minimaleEisen.startdatumZakelijkRecht = null;
			minimaleEisen.einddatumZakelijkRecht = null;
			minimaleEisen.toelichtingAnderOnroerendZakelijkRecht = "";
		}

		if (minimaleEisen.welkOnroerendZakelijkRecht === "121450000" || minimaleEisen.welkOnroerendZakelijkRecht == 121450000) {
			minimaleEisen.zakelijkRechtId = null;
			minimaleEisen.motiveringSportVlaanderenHeeftAanvragerLangdurigZakelijkRecht = "";
			minimaleEisen.startdatumZakelijkRecht = null;
			minimaleEisen.einddatumZakelijkRecht = null;
			minimaleEisen.toelichtingAnderOnroerendZakelijkRecht = "";
		}
	}

	onSave(event) {
		event.preventDefault();

		this.clearRechtenVelden(this.context.state.minimaleEisenPerInfrastructuur);

		if (this.context.state.fileSessionStarted) {
			showToastrInfo("Verwerken van bestanden. Even geduld");

			this.context.props.endFileSession(this.context.props.dossierId, domainConstants.DocumentTab.MinimaleEisen, this.context.props.infrastructuurId)
				.then(result => {
					if (!result.success) {
						showToastrError(domainConstants.HAS_FILE_EXCEPTION);
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: false });
						showToastrSuccess("Verwerken van bestanden gelukt");
					}
				});
		}

		this.context.props.saveMinimaleEisenPerInfrastructuur(this.context.state.minimaleEisenPerInfrastructuur, this.context.state.documenten)
			.then((notification) => {
				let isSaved = showToastr(notification);
				if (isSaved) {
					this.context.setState({ hasUnsavedChanges: false });
					this.context.props.loadInfrastructurenByDossierId(this.context.props.dossierId);
				}
			});
	}
}
